module.exports = __webpack_public_path__ + "image-1a61efb11a70.png";